import { ChromeOutlined, FormOutlined, QuestionOutlined, SearchOutlined} from "@ant-design/icons";
import { Typography } from "@mui/material";

const icons = {
  ChromeOutlined,
  QuestionOutlined,
  FormOutlined,
  SearchOutlined,
};

const support = {
  id: "support-accordion",
  title: (
    <Typography variant="h5" component="div">
      Support
    </Typography>
  ),
  type: "accordion",
  children: [
    {
      id: "ticket",
      title: "Get Help - Tickets",
      type: "item",
      url: "/ticket-view",
      icon: icons.FormOutlined,
    },
    {
      id: "workLogs",
      title: "Work Log",
      type: "item",
      url: "/work-log-view",
      icon: icons.FormOutlined,
    },
      {
      id: "auditLogs",
      title: "Audit Log",
      type: "item",
      url: "/audit-log-view",
      icon: icons.SearchOutlined,
    },
    {
      id: "documentation",
      title: "Documentation",
      type: "item",
      url: "",
      icon: icons.QuestionOutlined,
      external: true,
      target: true
    }
  ]
};

export default support;
